const API_URL = 'https://admin.educationcapsule.com/api';
const RUNWAY_API_KEY = 'key_2be7ca204798143e0faa9b8698c55602c867648f506d14e544cca569998ae92c84d8993ea59282ae9fa0fef6b09975bff4be7810b5421f1cd8d29213785a16f5';

export const generateQuiz = async ({
  subject,
  year,
  topic,
  difficulty,
  numberOfQuestions,
  language
}) => {
  try {
    const response = await fetch(`${API_URL}/ai/quiz/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        subject,
        year,
        topic,
        difficulty,
        number_of_questions: 5,
        language
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.questions) {
      throw new Error('Invalid quiz data received from server');
    }

    // Transform the API response to match our expected format
    return data.questions.map((q, index) => ({
      id: `question-${index}`,
      question: q.question,
      options: q.options,
      correctAnswer: q.correct_answer,
      explanation: q.explanation
    }));

  } catch (error) {
    console.error('Quiz generation failed:', error);
    throw new Error(error.message || 'Failed to generate quiz');
  }
};